var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["youtube-feed", "youtube-feed--" + this.profile] },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "youtube-feed__items" },
        [
          _vm._l(_vm.feed, function(item, index) {
            return index < _vm.pageLoads * _vm.count
              ? _vm._t(
                  "feed",
                  [
                    _c(
                      "div",
                      {
                        key: index,
                        staticClass: "youtube-feed__item",
                        class: _vm.itemClass("video")
                      },
                      [
                        _c(
                          "div",
                          { key: index, staticClass: "youtube-feed__image" },
                          [
                            _c(
                              "a",
                              { attrs: { href: item.link, target: "_blank" } },
                              [
                                _c("div", {
                                  staticClass: "image-container",
                                  style: _vm.imageStyle(item.thumbnail)
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.displayTitle
                          ? _c("h3", { staticClass: "heading" }, [
                              _c("a", {
                                attrs: {
                                  href: item.link,
                                  target: "_blank",
                                  rel: "external",
                                  title: item.title
                                },
                                domProps: { innerHTML: _vm._s(item.title) }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayDescription
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.truncate(
                                    item.description,
                                    250
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  ],
                  { index: index, item: item }
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.moreData && _vm.displayLoadMore
        ? _c("div", { staticClass: "load-more-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "load-more",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("Load More")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/YoutubeFeed.vue?vue&type=template&id=b15abc46&
// module id = 61
// module chunks = 7 9